<template>
  <div class="container-fluid device p-0">
    <div class="overlay" v-if="!isLoaded">
      <div class="overlay__inner">
        <div class="overlay__content">
          <span class="spinner"></span>
        </div>
      </div>
    </div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{txt('Report')}}</h1>
    </div>

    <!-- start row - PHONES SECTION (moved to first) -->
    <div class="row">
      <!-- html phone, 3 grids inside -->

      <div class="phone col-4" v-for="(phone, phoneName) in phones">
        <div class="row">
        <div class="col-12 name">
          {{ phoneName }}
          <br>
          <small class="text-white text-xs">{{ phone.desc }}</small>
        </div>

        <div class="col-6 slot wa" :class="getDeviceClass(phoneName, 'whatsappHost.01', phone)">
          WA 01
          <span v-show="$get(phone, 'whatsappHost.01')">{{ $get(phone, 'whatsappHost.01') }}</span>
        </div>

        <div class="col-6 slot wa" :class="getDeviceClass(phoneName, 'whatsappHost.02', phone)">
          WA 02
          <span v-show="$get(phone, 'whatsappHost.02')">{{ $get(phone, 'whatsappHost.02') }}</span>
        </div>

        <div class="col-6 slot wa" :class="getDeviceClass(phoneName, 'whatsappHost.01b', phone)">
          WA 01b
          <span v-show="$get(phone, 'whatsappHost.01b')">{{ $get(phone, 'whatsappHost.01b') }}</span>
        </div>

        <div class="col-6 slot wa" :class="getDeviceClass(phoneName, 'whatsappHost.02b', phone)">
          WA 02b
          <span v-show="$get(phone, 'whatsappHost.02b')">{{ $get(phone, 'whatsappHost.02b') }}</span>
        </div>
        
        <div class="col-6 slot sim" :class="getDeviceClass(phoneName, 'simHost.01', phone)">
          SIM 01
          <span v-show="$get(phone, 'simHost.01')">{{ $get(phone, 'simHost.01') }}</span>
        </div>
        
        <div class="col-6 slot sim" :class="getDeviceClass(phoneName, 'simHost.02', phone)">
          SIM 02
          <span v-show="$get(phone, 'simHost.02')">{{ $get(phone, 'simHost.02') }}</span>
        </div>
        <div class="col-6 slot sim" :class="getDeviceClass(phoneName, 'simHost.03', phone)" v-show="$get(phone, 'simHost.03')">
          SIM 03
          <span v-show="$get(phone, 'simHost.03')">{{ $get(phone, 'simHost.03') }}</span>
        </div>
      </div>
      <!-- end phone innner row -->
      </div>
      <!-- end phone -->
    </div>
    <!-- end row -->

    <div class="row">
      
      <div class="col-lg-12">
        <datepicker :placeholder="txt('Select Date')" v-model="date" :language="dLanguages[language]" name="endDate" id="edt"></datepicker>

        <div id="status"></div>
        <div class="table-responsive table-report" v-html="html">report table</div>
        <!-- <h2>device</h2>
        <div class="table-responsive table-report" v-html="reportDeviceHtml">device table</div> -->

        <h2>advanced</h2>
        <div class="table-responsive table-report" v-html="reportAdvanceHtml">advanced report table</div>
      </div>
    </div>
        
  </div>
</template>

<script>
import toast from "../services/toast";
import store from "../store/store";
import moment from "moment";
import _ from "lodash";
import {debounce} from "lodash";
// import $ from "jquery";
// import jQuery from "jquery";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import * as lang from "vuejs-datepicker/src/locale";

export default {
  name: "Report",
  components: {
      Datepicker,
    },
  // created(){
  //   this.isLoaded = true
  //   console.log('created billing')
  // },
  async mounted(a, b, c) {
    this._mounted()
  },

  beforeDestroy() {
    this.tableTimer && clearInterval(this.tableTimer)
  },
  // beforeRouteEnter: async function(to, from, next) {
  //   next(vm => {
  //     const app = vm;
  //     vm.getBillingDates();
  //   });
  // },
  data: function () {
    return {
      date: moment().startOf('day').toDate(),
      language: localStorage.getItem("activeLang").split("_")[0] || "zh",
      dLanguages: lang,

      html: null,
      reportAdvanceHtml: null,
      reportDeviceHtml: null,

      phoneSpecs: [], 
      phones: {}, 
      phoneSlotDisabled: {}, 

      billingInfo: {
        usageInfo: {},
      },
      billingDate: "",
      billingDates: "",
      billingDate: "",
      isLoaded: false,
      billingTotal: 0,
      tableTimer: null
    };
  },

  watch: {
    date: debounce(function (v) {
      // console.log('----sear ch phone X', {searchTerm})

      // this.date = v
      this.tableTimer && clearInterval(this.tableTimer)
      return this._mounted();
    }, 200),
  },

  methods: {
    getDeviceClass(phoneName, slotName, phone){
      let classes = []
      classes.push(_.get(phone, slotName) ? 'active' : '')
      classes.push(_.get(this.phoneSlotDisabled, `${phoneName}.${slotName}`) === false ? 'disabled' : '')

      return classes.join(' ')
    },
    async _mounted() {
      // console.log("mounted billing", { a, b, c, isLoaded: this.isLoaded });
      // this.billingDates = await this.getBillingDates();
      // this.billingDate = _.first(this.billingDates);
      // this.billingInfo = await this.getBillingInfo(this.billingDate)
      this.isLoaded = true;

      if (!$('#accordionSidebar').hasClass('toggled')){
        $('#accordionSidebar').addClass('toggled')
      }
      
      // let recaptchaScript = document.createElement("script");
      // recaptchaScript.setAttribute(
      //   "src",
      //   "https://lncknight.github.io/requestAnimationFrame/setIntervalAnimationFrame.js"
      // );
      // document.head.appendChild(recaptchaScript);

      this.getHtml(({
        html,
        reportAdvanceHtml,
        reportDeviceHtml,
      }) => {
        html.className =
          "table table-hover- table-sm table-striped table-bordered-";
        this.html = html.outerHTML;
        
        reportAdvanceHtml.className =
          "table table-hover- table-sm table-striped table-bordered-";
        this.reportAdvanceHtml = reportAdvanceHtml.outerHTML;

        reportDeviceHtml.className =
          "table table-hover- table-sm table-striped table-bordered-";
        this.reportDeviceHtml = reportDeviceHtml.outerHTML;
        
        // window.tmp = html
        // $("table").addClass(
        //   "table table-hover table-sm table-striped table-bordered"
        // );
      });
    },
    
    getHtml(callback) {
      let self = this;

      var json_visible = !0,
        json_pnl_size = 0,
        table_visible = !0,
        tree_visible = !0,
        tree_pnl_size = 0,
        xxa_pnl_size = 0;

      let getReportData = async () => {
        if (!self.axios) return 
        
        let { data: {ret: reportDeviceData, phoneSlotDisabled, devices: phoneSpecs } } = await self.axios.get("/phoneNumberInventory/slot", {
          params: {date: this.date}
        });
        // return $.get("https://api.supermeteor.com/report/status").promise();

        // mock reportDeviceData
        // let reportDeviceData = {
        //   "phone-law01": {
        //     "simHost": {
        //       "02": "cmhk-17",
        //       "01": "cmhk-13"
        //     },
        //     "whatsappHost": {
        //       "01b": "sg-06",
        //       "01": "cmhk-11",
        //       "02": "cmhk-10"
        //     }
        //   },
        //   "phone-01": {
        //     "whatsappHost": {
        //       "01": "hk-04",
        //       "02": "cmhk-17",
        //       "01b": "cmhk-13"
        //     }
        //   },
        // }
        // mock phoneSpecs
        // let phoneSpecs =
        //   [
        //     {
        //       "name": "phone-law01",
        //       "desc": "Huawei Mate 10 Pro"
        //     },
        //     {
        //       "name": "phone-01",
        //       "desc": "xiaomi"
        //     },
        //   ]
        self.phoneSpecs = phoneSpecs
        self.phones = reportDeviceData
        // enrich phones with phoneSpecs
        self.phones = _.mapValues(self.phones, (phone, phoneName) => {
          let phoneSpec = _.find(phoneSpecs, {name: phoneName})
          return {
            ...phone,
            ...phoneSpec
          }
        })
        // sort by keys asc order, e.g. phone-01, phone-law01, etc
        self.phones = _.fromPairs(_.toPairs(self.phones).sort())
        // console.log(self.phones)
        self.phoneSlotDisabled = phoneSlotDisabled

        let { data } = await self.axios.get("/report/status", {
          params: {date: this.date}
        });
        let { data: reportAdvanceData } = await self.axios.get("/report/advance", {
          params: {date: this.date}
        });


        return {
          data,
          reportAdvanceData,
          reportDeviceData,
        };
      };

      // a("#load_json_btn").click(function () {
      //   processJson();
      // });

      let lastUpdatedAt = new Date();
      let loadAndDisplayDashboard = async () => {
        // console.log("loadAndDisplayDashboard-----------");
        // console.log('getReportData',asdadasd)
        $("#status").text("loading..");
        let {data, reportAdvanceData, reportDeviceData} = await getReportData();
        // console.log({ rs });
        let html = await processJson(data);
        let reportAdvanceHtml = await processJson(reportAdvanceData);
        let reportDeviceHtml = await processJson(reportDeviceData);

        callback && callback({
          html,
          reportAdvanceHtml,
          reportDeviceHtml,
        });

        lastUpdatedAt = new Date();
        updateTimestamp()

        // $.get("https://api.supermeteor.com/report/status", (rs) => {
        //   $("#json_vl").val(JSON.stringify(rs));
        //   processJson(callback);
        //   $("#inner_tbl > table").addClass(
        //     "table table-hover table-sm table-striped table-bordered"
        //   );

        //   // $('#text').text(`latest update: ${new Date()}`)
        //   // console.log(
        //   //   new Date(),
        //   //   new Date().getTime() - lastUpdatedAt.getTime()
        //   // );

        //   lastUpdatedAt = new Date();
        // });
      };

      let updateTimestamp = () => {
        $("#status").text(
          `latest update: ${moment(lastUpdatedAt).fromNow()} (${moment(
            lastUpdatedAt
          ).format("Y-MM-DD HH:mm:ss")})`
        );
        $("#status").attr(
          "title",
          moment(lastUpdatedAt).format("Y-MM-DD HH:mm:ss")
        );
      };

      loadAndDisplayDashboard();
      self.tableTimer = setInterval(() => {
        if (document.hidden){
          if (_.random(1, 100) < 90){
            console.log("window not active, skip reload");
            return 
          }
        }
        
        loadAndDisplayDashboard()
      }, 5000)
      // self.tableTimer = setInterval(loadAndDisplayDashboard, 1000) // TODO remove test
      // setIntervalAnimationFrame(updateTimestamp, 1000);

      var g;

      function loadfromURL(a, callback) {
        $("#json_vl").val("Loading...");
        $("#inner_tree").html("");
        $("#inner_tbl").html("");
        "http" != a.substr(0, 4) && (a = "http://" + a);
        $.ajax({
          type: "GET",
          url: "http://json2table-env-ayji8pibkt.elasticbeanstalk.com/getjson",
          data: {
            callback: "call",
            url: encodeURIComponent(a),
          },
          contentType: "application/json",
          dataType: "jsonp",
          success: function (a) {
            $("#json_vl").val(JSON.stringify(a, void 0, 2));
            processJson();
          },
          error: function (e) {
            $("#json_vl").val("");
            $("#error_msg").text("Not a valid JSON from " + a);
            //      $("#errorModal").modal("show");
            return {};
          },
        });
      }

      function call(a) {
        $("#json_vl").val(JSON.stringify(a, void 0, 2));
        processJson();
      }

      async function processJson(data = []) {
        // console.log('data', data)
        let html = buildTable(data);
        // console.log({ html: html.outerHTML });
        // callback && callback(html.outerHTML);
        // $("#inner_tbl").html(buildTable(getJsonVar()));
        // showTree();

        return html;
      }

      function buildTable(a) {
        var e = document.createElement("table"),
          d,
          b;
        if (isArray(a)) return buildArray(a);
        for (var c in a)
          "object" != typeof a[c] || isArray(a[c])
            ? "object" == typeof a[c] && isArray(a[c])
              ? ((d = e.insertRow(-1)),
                (b = d.insertCell(-1)),
                (b.colSpan = 2),
                (b.innerHTML =
                  '<div class="td_head">' +
                  encodeText(c) +
                  '</div><table style="width:100%">' +
                  $(buildArray(a[c]), !1).html() +
                  "</table>"))
              : ((d = e.insertRow(-1)),
                (b = d.insertCell(-1)),
                (b.innerHTML =
                  "<div class='td_head'>" + encodeText(c) + "</div>"),
                (d = d.insertCell(-1)),
                (d.innerHTML =
                  "<div class='td_row_even'>" + encodeText(a[c]) + "</div>"))
            : ((d = e.insertRow(-1)),
              (b = d.insertCell(-1)),
              (b.colSpan = 2),
              (b.innerHTML =
                '<div class="td_head">' +
                encodeText(c) +
                '</div><table style="width:100%">' +
                $(buildTable(a[c]), !1).html() +
                "</table>"));
        return e;
      }

      function buildArray(a) {
        var e = document.createElement("table"),
          d,
          b,
          c = !1,
          p = !1,
          m = {},
          h = -1,
          n = 0,
          l;
        l = "";
        let td_class;
        if (0 == a.length) return "<div></div>";
        d = e.insertRow(-1);
        for (var f = 0; f < a.length; f++)
          if ("object" != typeof a[f] || isArray(a[f]))
            "object" == typeof a[f] && isArray(a[f])
              ? ((b = d.insertCell(h)),
                (b.colSpan = 2),
                (b.innerHTML =
                  '<div class="td_head"></div><table style="width:100%">' +
                  $(buildArray(a[f]), !1).html() +
                  "</table>"),
                (c = !0))
              : p ||
                ((h += 1),
                (p = !0),
                (b = d.insertCell(h)),
                (m.empty = h),
                (b.innerHTML = "<div class='td_head'>&nbsp;</div>"));
          else
            for (var k in a[f])
              (l = "-" + k),
                l in m ||
                  ((c = !0),
                  (h += 1),
                  (b = d.insertCell(h)),
                  (m[l] = h),
                  (b.innerHTML =
                    "<div class='td_head'>" + encodeText(k) + "</div>"));
        c || e.deleteRow(0);
        n = h + 1;
        for (f = 0; f < a.length; f++)
          if (
            ((d = e.insertRow(-1)),
            (td_class = isEven(f) ? "td_row_even" : "td_row_odd"),
            "object" != typeof a[f] || isArray(a[f]))
          )
            if ("object" == typeof a[f] && isArray(a[f]))
              for (h = m.empty, c = 0; c < n; c++)
                (b = d.insertCell(c)),
                  (b.className = td_class),
                  (l =
                    c == h
                      ? '<table style="width:100%">' +
                        $(buildArray(a[f]), !1).html() +
                        "</table>"
                      : " "),
                  (b.innerHTML =
                    "<div class='" +
                    td_class +
                    "'>" +
                    encodeText(l) +
                    "</div>");
            else
              for (h = m.empty, c = 0; c < n; c++)
                (b = d.insertCell(c)),
                  (l = c == h ? a[f] : " "),
                  (b.className = td_class),
                  (b.innerHTML =
                    "<div class='" +
                    td_class +
                    "'>" +
                    encodeText(l) +
                    "</div>");
          else {
            for (c = 0; c < n; c++)
              (b = d.insertCell(c)),
                (b.className = td_class),
                (b.innerHTML = "<div class='" + td_class + "'>&nbsp;</div>");
            for (k in a[f])
              (c = a[f]),
                (l = "-" + k),
                (h = m[l]),
                (b = d.cells[h]),
                (b.className = td_class),
                "object" != typeof c[k] || isArray(c[k])
                  ? "object" == typeof c[k] && isArray(c[k])
                    ? (b.innerHTML =
                        '<table style="width:100%">' +
                        $(buildArray(c[k]), !1).html() +
                        "</table>")
                    : (b.innerHTML =
                        "<div class='" +
                        td_class +
                        "'>" +
                        encodeText(c[k]) +
                        "</div>")
                  : (b.innerHTML =
                      '<table style="width:100%">' +
                      $(buildTable(c[k]), !1).html() +
                      "</table>");
          }
        return e;
      }

      function encodeText(a) {
        return $("<div />").text(a).html();
      }

      function isArray(a) {
        return "[object Array]" === Object.prototype.toString.call(a);
      }

      function isEven(a) {
        return 0 == a % 2;
      }

      function buildTree(a, e, d) {
        e += 1;
        if ("undefined" === typeof a) log("undef!!", e);
        else
          for (var b in a)
            if ("object" == typeof a[b]) {
              var c = addTree(b, d, isArray(a[b]));
              buildTree(a[b], e, c);
            } else addLeaf(b, a, d);
      }

      function addTree(a, e, d) {
        var b = "lbl_obj";
        d && (b = "lbl_array");
        var c = "_" + Math.random().toString(36).substr(2, 9);
        d = document.createElement("li");
        d.innerHTML =
          "<label for='" +
          c +
          "' class='" +
          b +
          "'>" +
          encodeText(a) +
          "</label> <input type='checkbox' checked id='" +
          c +
          "' />";
        a = document.createElement("ol");
        d.appendChild(a);
        null != e && e.appendChild(d);
        return a;
      }

      function addLeaf(a, e, d) {
        var b = "";
        isArray(e) || (b = a + ":");
        b += e[a];
        Math.random().toString(36).substr(2, 9);
        a = document.createElement("li");
        a.className = "file";
        a.innerHTML = "<a>" + encodeText(b) + "</a>";
        d.appendChild(a);
      }

      function log(a, e, d) {
        console.log(a);
      }
    },
  },
};
</script>

<style scoped>
#status {
  text-align: left;
}
.table-report {
  text-align: left;
}
.table-report >>> .td_head {
  font-weight: 900;
}
.wa {
  background: rgb(233, 245, 233);
}
.wa.active {
  background: rgb(15, 150, 15);
}
.sim {
  background: rgb(239, 235, 228);
}
.sim.active {
  background: rgb(227, 160, 34);
}
.slot {
  /* padding: 30px 5px; */
  height: 75px;
  border: 1px solid #555;
  color: #222;
  font-size: 14px;
}
.slot span {
  display: block;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
  color: #000
}
.slot.disabled {
  opacity: 0.2;
  background: #eee;
}
.phone .name {
  border: 1px solid #555;
  background: #545353;
  padding: 10px 5px;
  text-transform: uppercase;
  color: #eee
}
</style>